/**
 * Utility to format dates and times to California (PST/PDT) time.
 */

export const formatDateToPST = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'America/Los_Angeles'
    });
};

export const formatTimeToPST = (dateString) => {
    if (!dateString) return 'Live';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Los_Angeles'
    });
};
